import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2InvStorageManfSave,
  wind2InvStorageManf,
  wind2InvStorageManfDelete,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'

const Wind2InvStroageManf = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 300px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Manufacturer Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Manufacturer Code :</Label> */}
        <Input
          value={insertData.manufacturerCode}
          data-cy="manufacturercode"
          onChange={e =>
            setInsertData({
              ...insertData,
              manufacturerCode: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Manufacturer Name :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Manufacturer Name :</Label> */}
        <Input
          value={insertData.manufacturerName}
          data-cy="manufacturername"
          onChange={e =>
            setInsertData({
              ...insertData,
              manufacturerName: e.target.value,
            })
          }
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }
  return (
    <CommonScreen
      title="Inv Storage Manufacturer"
      header={Wind2StorageInvManufacturerHeaders}
      sortOptions={Wind2StorageInvManufacturerHeaders}
      saveTask={wind2InvStorageManfSave}
      retrieveTask={wind2InvStorageManf}
      deleteTask={wind2InvStorageManfDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={900}
      // heightOffset={100}
    />
  )
}

export default Wind2InvStroageManf

const Wind2StorageInvManufacturerHeaders = [
  strCol({
    ident: 'manufacturerCode',
    display: 'Manufacturer Code',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'manufacturerName',
    display: 'Manufacturer Name',
    isKey: true,
    width: 350,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]
